import React, { Component } from 'react';
import { bool, func, string } from 'prop-types';

import classes from './ImageUploadInput.module.css';

export default class ImageUploadInput extends Component {
    state = {
        fileName: null,
        photoUrl: null
    }


    componentDidMount() {
        const { fileName, hasPhoto, photoUrl } = this.props;
        if (hasPhoto && photoUrl) {
            this.setState({ fileName, photoUrl: photoUrl });
        }
    }

    componentDidUpdate(prevProps) {
        const { fileName, photoUrl } = this.props;

        if (prevProps.fileName !== fileName) {
            this.setState({ fileName, photoUrl: photoUrl });
        }
    }

    handleUpload = ({ target }) => {
        const fileReader = new FileReader();

        fileReader.readAsDataURL(target.files[0]);
        fileReader.onload = e => {
            this.setState(() => ({
                fileName: target.files[0].name,
                photoUrl: e.target.result
            }));

            this.props.upload({
                image:     e.target.result,
                imageName: target.files[0].name
            });
        };
    };

    handleClearFile = () => {
        this.setState(() => ({
            photoUrl: null,
            fileName: null
        }));

        this.props.clear();
    }

    render() {
        const { accept } = this.props;

        if (this.state.photoUrl) {
            return (
                <div className={classes.imageContainer}>
                    <img
                        src={this.state.photoUrl}
                        alt="technician"
                        height="147"
                        width="147"
                    />
                    <button className={classes.remove} onClick={this.handleClearFile}>Remove Technician Picture</button>
                </div>
            );
        }
        
        else {
            return (
                <div className={classes.imageContainer}>
                    <img
                        src="/assets/images/hardHatFlat.svg"
                        alt="technician"
                        height="147"
                        width="147"
                    />
                    <input
                        className={classes.input}
                        accept={accept}
                        onChange={this.handleUpload}
                        id="fileId"
                        type="file"
                        key={this.state.fileName}
                        title=""
                    />
                </div>
            );
        }
    }
}

ImageUploadInput.propTypes = {
    accept:   string.isRequired,
    clear:    func.isRequired,
    fileName: string,
    hasPhoto: bool,
    photoUrl: string,
    upload:   func.isRequired,
};
